import {ChangeDetectionStrategy, Component, ElementRef, HostListener, OnInit, ViewChild} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { TimeagoModule } from 'ngx-timeago';
import { LazyLoadImageModule } from 'ng-lazyload-image';

import { PunkGridViewComponent } from '@/components/punk-grid-view/punk-grid-view.component';
import { TxOverviewComponent } from '@/components/overview/overview.component';

import { WeiToEthPipe } from '@/pipes/wei-to-eth.pipe';

import { DataService } from '@/services/data.service';
import { Web3Service } from '@/services/web3.service';
import { StateService } from '@/services/state.service';
import { ThemeService } from '@/services/theme.service';
import { PlatformService } from '@/services/platform.service';

import { FilterPipe } from '@/pipes/filter.pipe';
import { CalcPipe } from '@/pipes/calculate.pipe';
import { CountPipe } from '@/pipes/count.pipe';
import { TokenIdParsePipe } from '@/pipes/token-id-parse.pipe';

import { Punk } from '@/models/graph';

import {debounceTime, Observable, Subject} from 'rxjs';
import {environment} from "../../../environments/environment";

@Component({
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    TimeagoModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    LazyLoadImageModule,

    PunkGridViewComponent,
    TxOverviewComponent,

    WeiToEthPipe,
    FilterPipe,
    CalcPipe,
    CountPipe,
    TokenIdParsePipe
  ],
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss']
})

export class IndexComponent implements OnInit {

  allData$!: Observable<Punk[]>;

  punkBoxLoading: boolean = false;
  punkBoxError: boolean = false;

  punkBox: FormGroup = new FormGroup({
    addressInput: new FormControl()
  });

  randomPunks: string[] = [];
  visibleRandomPunks: string[] = [];
  resize$ = new Subject<void>();
  @ViewChild('introPunks') introPunksElement!: ElementRef;

  constructor(
      public themeSvc: ThemeService,
      public stateSvc: StateService,
      public dataSvc: DataService,
      public web3Svc: Web3Service,
      private router: Router,
      private platformService: PlatformService
  ) {
    this.allData$ = this.dataSvc.getAllData();
  }

  ngOnInit(): void {
    if (environment.collection === 'cryptophunks') {
      this.randomPunks = [ ...Array.from({length: 30}, () => `${Math.floor(Math.random() * 10000)}`)]
      this.numberOfDigits = '1.3-3'
    } else if (environment.collection === 'cryptopunks-v1') {
      this.randomPunks = Array.from({length: 15}, () => `${Math.floor(Math.random() * 10000)}`)
    } else {
      this.randomPunks = [ '7209', ...Array.from({length: 9}, () => `${Math.floor(Math.random() * 10000)}`)]
    }
    this.resize$.pipe(debounceTime(200))
        .subscribe(() => this.computeVisibleItems());
    this.platformService.setTimeout(() => this.computeVisibleItems(), 0);
  }

  private computeVisibleItems() {
    const containerWidth = this.introPunksElement.nativeElement.offsetWidth;
    console.log('containerWidth', containerWidth);
    if (environment.collection === 'cryptophunks') {
      if (containerWidth < 450) {
        this.visibleRandomPunks = this.randomPunks.slice(0, Math.floor(containerWidth/66)*2);
      } else {
        this.visibleRandomPunks = this.randomPunks.slice(0, Math.floor(containerWidth/75));
      }
    } else{
      this.visibleRandomPunks = this.randomPunks;
    }
  }

  @HostListener('window:resize')
  onResize() {
    this.resize$.next();
  }

  async onSubmit($event: any): Promise<void> {
    try {
      this.punkBoxLoading = true;

      const addressInput  = this.punkBox?.value?.addressInput;
      let address = addressInput;

      const isEns = addressInput?.includes('.eth');
      const isAddress = this.web3Svc.verifyAddress(addressInput);
      const isTokenId = Number(addressInput) < 10000 && Number(addressInput) > 0;

      if (!isEns && !isAddress && !isTokenId) throw new Error('Invalid Address');

      if (isTokenId) {
        this.router.navigate(['/', 'details', `${Number(addressInput)}`]);
        this.punkBoxLoading = false;
        return;
      }

      if (isEns) address = await this.web3Svc.getEnsOwner(addressInput);
      else address = this.web3Svc.verifyAddress(addressInput);

      if (address) this.router.navigate(['/', 'owned'], { queryParams: { address }});
      else throw new Error('Invalid Address');

      this.punkBoxLoading = false;

    } catch (error) {
      console.log(error);
      this.punkBoxLoading = false;
      this.punkBoxError = true;
    }
  }

  protected readonly environment = environment;
  numberOfDigits: string = '1.2-2';
}
